import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBK9vZc8P5PhldlyjsDBz0OBN_TZ913GvU",
  authDomain: "linkedin-clone-508f1.firebaseapp.com",
  projectId: "linkedin-clone-508f1",
  storageBucket: "linkedin-clone-508f1.appspot.com",
  messagingSenderId: "25166059241",
  appId: "1:25166059241:web:48e7b616fdd3fd06324278",
  measurementId: "G-SDRW45JXKG"
};

//connects everything
const firebaseApp= firebase.initializeApp(firebaseConfig);

//firebase databse
const db = firebaseApp.firestore();

const auth= firebase.auth();
export {db, auth};